import React from 'react'
import { Route, Switch } from 'react-router-dom'
import {MerchantDetailsView} from '../../components/MleMakerChecker'
import Checker from './Checker';
import MleRequestedApprovalView from './MleRequestedApprovalView';

const MleRequestedApprovalRoute = () => {
  return (
    <Switch>
        <Route exact path ="/checker">
          <Checker />
        </Route>
        <Route exact path ="/checker/:tabname/:id">
          <MleRequestedApprovalView />
        </Route>
    </Switch>
  )
}

export default MleRequestedApprovalRoute